<template>
  <IconLucideBookImage />
</template>
